<template>

<div id="consultaNotas">
  <div v-if="this.$router.history.current.path == '/docsFederal' || this.$router.history.current.path == '/docsMunicipal'" class="descTable">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h2 style="color:white; box-shadow: 1px 1px 8px black;">
            <v-icon style="margin-left: 87px;" color="white">mdi-folder-open</v-icon>
            <!-- <svg
              style="width:24px;height:24px; margin-left: 87px;margin-bottom: -4px;"
              viewBox="0 0 24 24"
            >
              <path
                fill="#FFF"
                d="M19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.67 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,12.97M6.5,12C6.5,12.58 6.59,13.13 6.75,13.66L4.68,15.36L5.43,16.66L7.95,15.72C8.69,16.53 9.68,17.12 10.8,17.37L11.24,20H12.74L13.18,17.37C14.3,17.13 15.3,16.54 16.05,15.73L18.56,16.67L19.31,15.37L17.24,13.67C17.41,13.14 17.5,12.58 17.5,12C17.5,11.43 17.41,10.87 17.25,10.35L19.31,8.66L18.56,7.36L16.06,8.29C15.31,7.47 14.31,6.88 13.19,6.63L12.75,4H11.25L10.81,6.63C9.69,6.88 8.69,7.47 7.94,8.29L5.44,7.35L4.69,8.65L6.75,10.35C6.59,10.87 6.5,11.43 6.5,12M12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5Z"
              ></path> -->
            <!-- </svg> -->
            {{ this.$router.history.current.path == '/docsFederal' ? 'Documentos Federais' : 'Documentos Municipais' }}
            <transition name="slide-fade">
              <v-icon v-if="!empresa._id" class="mr-2 ml-2 loading fechamento_loop">loop</v-icon>
            </transition>
          </h2>
        </v-flex>
      </v-layout>
    </div>
    <article v-if="this.empresa == '' || this.empresa == undefined" class="text-xs-center" style="margin: 38px 2px 20px -100px;">
      <svg class="custom_anime" style="width:55px;height:45px" viewBox="0 0 24 24">
        <path style="fill: white;" d="M14,3V13L17.2,11.31L17.42,11.28C17.71,11.28 17.97,11.4 18.16,11.6L18.9,12.37L14,16.57C13.74,16.84 13.39,17 13,17H6.5C5.73,17 5,16.3 5,15.5V11.14C5,10.53 5.35,10 5.85,9.8L10.79,7.6L12,7.47V3A1,1 0 0,1 13,2A1,1 0 0,1 14,3M5,19H13V22H5V19Z" />
      </svg>
    </article>
    <RenderTableNFe @getNewEmp="getNewEmp($event)" v-else :empresa="this.empresa" :conta="this.conta" :alert="this.alert" :IBGE="this.IBGE"></RenderTableNFe>
</div>
</template>

<script>
import Menu from "@/components/menu/Menu.vue";
import RenderTableNFe from "@/components//dataTable/RenderTableNFe.vue";
export default {
  components: {
    mainMenu: Menu,
    RenderTableNFe: RenderTableNFe
  },
  props: ["conta","empresa", "alert", 'IBGE'],
  data() {
    return {
      select: "",
      route: this.$router.history.current.path,
      tabs: [
        {
          title: "Recebidas"
        },
        {
          title: "Enviadas"
        }
      ]
    };
  },
  updated: function() {
    this.$nextTick(function() {
    
    });
  },

  computed: {
    getSelect: function() {}
  },
  methods: {
    getNewEmp: function($event) {
      this.$emit("getNewEmp", $event);
    }
  },

  beforeMount: function() {
    this.$nextTick(function() {});
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component.name only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  text-decoration: none;
  color: #42b983;
}
.iconCloud {
  transform: rotate(180deg);
}
#panelEmpresa {
  padding: 30px 0;
  background: #e3f2fd;
}
#panelEmpresa h1 {
  font-family: "Quicksand", sans-serif;
}
#tabOption {
  font-size: 15px;
  font-weight: bold;
}

#consultaNotas h2 {
  font-weight: normal;
  background-color: teal;
}
#consultaNotas .fechamento_loop {
  font-size: 22px;
  font-weight: bold;
  color: cyan;
}
#consultaNotas .desc_ribbon {
  margin: 0px auto;
  width: 100%;
  text-align: center;
  display: inline-block;
  color: grey;
  font-weight: bold;
}

.loading {
  animation-name: loading;
  animation: loading 2s infinite;
}
@-webkit-keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }
  to {
    transform: rotate(180deg) scaleX(-1);
  }
}

@keyframes loading {
  from {
    transform: rotate(0) scaleX(-1);
  }

  to {
    transform: rotate(180deg) scaleX(-1);
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/loggedArea/consultaNotas/ConsultaNotas.vue